import { httpClient } from './http-client';
import { API_ENDPOINTS } from '../config/api';

export interface DnaLabItem {
  id: number;
  organizationName: string;
  testingMethod: number;
  testingMethodName: string;
  regionId?: number | null;
  region?: { id: number; nameRu: string; nameKz: string; nameEn: string } | null;
  address?: string | null;
  phoneNumber: string;
  email: string;
  createdAt: string;
  updatedAt?: string | null;
}

export interface CreateDnaLabRequest {
  organizationName: string;
  testingMethod: number;
  regionId?: number | null;
  address?: string | null;
  phoneNumber: string;
  email: string;
}

const BASE = API_ENDPOINTS.DNA_LAB;

export const dnaLabService = {
  getAll(testingMethod?: number, regionId?: number) {
    const params = new URLSearchParams();
    if (testingMethod !== undefined) params.set('testingMethod', String(testingMethod));
    if (regionId !== undefined) params.set('regionId', String(regionId));
    const qs = params.toString();
    return httpClient.get<DnaLabItem[]>(BASE + (qs ? `?${qs}` : ''));
  },

  getById(id: number) {
    return httpClient.get<DnaLabItem>(`${BASE}/${id}`);
  },

  create(body: CreateDnaLabRequest) {
    return httpClient.post<DnaLabItem>(BASE, body);
  },

  update(id: number, body: CreateDnaLabRequest) {
    return httpClient.put<DnaLabItem>(`${BASE}/${id}`, body);
  },

  delete(id: number) {
    return httpClient.delete(`${BASE}/${id}`);
  },
};
